import { sortBy, toPairs, groupBy } from "lodash-es";
import { useMemo } from "react";
import { type CountryCodeValue } from "@/main";
import countryConfig from "$/open_dict/country.json";

export const useContryCodeMaps = () => {
  return useMemo(() => {
    const codes = Object.keys(countryConfig) as CountryCodeValue[];
    const res1 = codes
      .map((s) => ({
        code: s,
        firstChat: s[0]?.toUpperCase(),
      }))
      .filter((x) => (x?.firstChat ? /^[A-Z]$/.test(x.firstChat) : false));

    const res2 = sortBy(
      toPairs(groupBy(res1, (x) => x.firstChat)),
      (x) => x[0],
    ).map(([letter, arr]) => ({
      label: letter,
      value: arr
        .map((i) => i.code)
        .sort((a, b) => countryConfig[a].rank - countryConfig[b].rank), // 原始字符串集合
    }));

    return res2;
  }, []);
};
